import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { formatTimestamp, formatDisplayName } from "./helpers";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ExpandableText from "./ExpandableText";

const ReplyComment = ({ name, picture, content, attachments, date }) => {
  const displayName = formatDisplayName(name);
  return (
    <Box
      sx={{
        pl: 4,
        mb: 2,
        borderLeft: "2px solid #e0e0e0",
      }}
      className="reply-comment"
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Avatar
          sx={{ mr: 1, width: 30, height: 30 }}
          src={picture || undefined}
          imgProps={{
            style: { objectFit: "cover" },
            referrerPolicy: "no-referrer",
          }}
        >
          {(displayName && displayName[0]) || "?"}
        </Avatar>
        <Typography variant="subtitle2">{displayName}</Typography>
        <Typography variant="caption" sx={{ ml: "auto" }}>
          {formatTimestamp(date)}
        </Typography>
      </Box>
      <Box sx={{ mb: 1 }}>
        <ExpandableText
          text={content}
          lines={5}
          variant="body2"
          contentClassName="reply-content"
        />
      </Box>

      {/* Display attachments if any */}
      {attachments && attachments.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            mt: 1,
            mb: 1,
          }}
        >
          {attachments.map((attachment, index) => (
            <Box
              key={index}
              sx={{
                width: "40px",
                height: "40px",
                position: "relative",
                borderRadius: "4px",
                overflow: "hidden",
                border: "1px solid #e0e0e0",
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              }}
              onClick={() => {
                if (attachment.url) {
                  window.open(attachment.url, "_blank");
                }
              }}
            >
              {attachment.isImage ? (
                <img
                  src={attachment.url}
                  alt={attachment.filename}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {attachment.contentType?.includes("pdf") ? (
                    <PictureAsPdfIcon sx={{ color: "#f44336" }} />
                  ) : attachment.contentType?.includes("word") ||
                    attachment.contentType?.includes("document") ? (
                    <DescriptionIcon sx={{ color: "#2196f3" }} />
                  ) : attachment.contentType?.includes("excel") ||
                    attachment.contentType?.includes("sheet") ? (
                    <TableChartIcon sx={{ color: "#006aff" }} />
                  ) : (
                    <InsertDriveFileIcon sx={{ color: "#757575" }} />
                  )}
                </Box>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ReplyComment;
